import { SidebarIconProps } from "../../../types";

export default function OrganizationIcon({ collapsed }: SidebarIconProps) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.3)" }}
        className={collapsed ? "" : "relative left-[5.2px]"}
      >
        <path
          d="M18.75 6.125L14.375 1.125H5.625L1.25 6.125M18.75 6.125L10 15.5M18.75 6.125H1.25M10 15.5L1.25 6.125M10 15.5L13.8352 6.125L10 1.125L6.16477 6.125L10 15.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
